import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=39501346&scoped=true&"
import script from "./Home.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Home.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Home.vue?vue&type=style&index=0&id=39501346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39501346",
  null
  
)

export default component.exports